<template>
  <div class="PreviewWindowsChrome" :class="{ 's-hasImage': hasImage }">
      <div class="Icon" :style="{'backgroundImage': 'url(' + base.icon + ')'}"></div>
      <div class="Details">
          <div class="Title" ref="title" v-html="base.title"></div>
          <div class="Body" ref="body" v-html="base.body"></div>
          <div class="Info" v-html="base.domain"></div>
      </div>
      <div v-if="hasImage" class="Image" :style="{'backgroundImage': 'url(' + base.image + ')'}"></div>
      <div v-if="hasMenu" class="Menu">
        <div><div class="MenuIcon"></div><span v-html="base.action1Text"></span></div>
        <div v-if="base.action2Text" v-html="base.action2Text"></div>
      </div>
  </div>
</template>

<script>

// import lineClamp from 'line-clamp'

export default {
  name: 'PreviewWindowsChrome',
  props: {
    base: Object
  },
  data() {
    return {
    }
  },
  computed: {
    hasMenu() {
      return !!this.base.action1Text
    },
    hasImage() {
      return !!this.base.image
    }
  },
  mounted() {
    // lineClamp(this.$refs.title, 2)
    // lineClamp(this.$refs.body, 3)
  }
}
</script>

<style scoped lang="less">
  .PreviewWindowsChrome {
    width: 360px;
    min-height: 80px;
    user-select: none;
    position: relative;
    border: 1px solid #dedede;
    font-family: 'Open Sans', sans-serif;
    box-shadow: 0px 0px 5px rgb(222, 222, 222);
    background: #fff url('../assets/icon-windows-settings-close.png') no-repeat 315px 9px;
  }
  .Icon {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 0px;
    left: 0px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .Details {
    margin-left: 97px;
    margin-top: 13px;
    margin-bottom:  16px;
    color: #000;
    .Title {
      font-size: 10px;
      width: 210px;
    }
    .Body {
      font-size: 9px;
      width: 250px;
      margin-top: 10px;
    }
    .Info {
      margin-top: 15px;
      font-size: 9px;
      color: #7f7f7f;
    }
  }
  .s-hasImage .Body {
    display: none !important;
  }
  .Image {
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 340px;
    height: 191px;
    margin-left: 9px;
    margin-top: 35px;
    margin-bottom: 25px;
  }
  .Menu {
    color: #000;
    & > div {
      height: 38px;
      border-top: 1px solid #dedede;
      font-size: 10px;
      padding-left: 17px;
      padding-top:11px;
    }
    .MenuIcon {
      display: inline-block;
      display: none;
      background: #ccc;
      width: 13px;
      height: 13px;
      margin-right: 5px;
      position: relative;
      top: 1px;
      vertical-align: text-top;
    }
    & > div:hover {
      background: #ddd;
    }
  }
</style>
